import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myWordCasePipe'
})
export class WordCasePipe implements PipeTransform {

    transform(input: string) {
        if (input === undefined || input === null || input === ',') {
            return '';
        }
        return input.split(' ')
            .map(w =>
            {
                if (w.length === 2) {
                    return w.toUpperCase();
                }
                if (w[0] !== undefined) {
                    return w[0].toUpperCase() + w.substr(1).toLowerCase();
                } else {
                    return '';
                }

            })
            .join(' ')
            .split('/')
            .map(w => {
                if (w[0] !== undefined) {
                    return w[0].toUpperCase() + w.substr(1);
                } else {
                    return '';
                }

            })
            .join('/')
            .split('(')
            .map(w => {
                if (w[0] !== undefined) {
                    return w[0].toUpperCase() + w.substr(1);
                } else {
                    return '';
                }

            })
            .join('(');

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/word-case.pipe.ts